import React, { useState, useEffect } from "react";
import Card from "./Cards";
import MyChart from "./MyChart"
import { getLeads } from "../../services/api/api";
import { fetchData } from "../utils/Function/Helper";
import { useSelector } from "react-redux";

export default function Dashboard() {
  const user = useSelector((state) => state.user);
  let emptyLead = {
    superadmin_id: user?.userDetails?.ID || null,
    teamlead_id: user?.userDetails?.TeamLeadID || null,
    user_id: user?.userDetails?.UserID || null,
    lead_status: "All",
  };

  const [leads, setLeads] = useState([]);

  // get datas
  useEffect(() => {
    setLeads([]);
    fetchData(() => getLeads(emptyLead), setLeads);
  }, [user]);

  return (
    <>
      <Card leads={leads} />
      <div className="row mt-3">
        <div className=" col-12">
          <div className="chart-div"><MyChart leads={leads} /></div>
        </div>
      </div>
    </>
  );
}
